<template>
  <div class="container">
    <div class="container_form">
      <el-form
        :inline="true"
        :model="formObj"
        style="
          padding-top: 20px;
          padding-left: 20px;
          margin-bottom: 20px;
          background-color: #fff;
          border-radius: 8px;
        "
        size="small"
        ref="formObjRefs"
      >
        <el-form-item label="结算批次名称" prop="settlementBatchName">
          <el-select
            filterable
            style="width: 100%"
            v-model="formObj.settlementBatchName"
            placeholder="请选择结算批次名称"
          >
            <el-option
              v-for="(item, index) in queryFormSettlementList"
              :key="index"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="结算师傅名称" prop="installerIds">
          <el-select
            multiple
            style="width: 100%"
            filterable
            v-model="formObj.installerIds"
            placeholder="请选择结算师傅名称"
          >
            <el-option
              v-for="item in allUserList"
              :key="item.id"
              :label="item.userName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="公司名称" prop="companyIds">
          <el-select
            multiple
            style="width: 100%"
            filterable
            v-model="formObj.companyIds"
            placeholder="请选择公司名称"
          >
            <el-option
              v-for="item in companyList"
              :key="item.companyId"
              :label="item.companyManager"
              :value="item.companyId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" @click="getPageData(true)"
            >查询</el-button
          >
          <el-button type="info" size="mini" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>

      <div class="container_table">
        <!-- 金额统计 -->
        <AmountStatistics v-bind="amountStatistics" />
        <div class="table-header" style="margin: 0 0 13px -4px">
          <el-button
            type="primary"
            icon="el-icon-coin"
            size="mini"
            @click="payMerge()"
            style="margin-left: 5px"
            >合并支付</el-button
          >
        </div>
        <BaseTable
          :tableData="tableData"
          :columns="columns"
          :showPagination="true"
          :showOperationColumn="true"
          :operationColumnWidth="220"
          :total="total"
          @size-change="onSizeChange"
          @current-change="onCurrentChange"
          selection-fixed="left" :isSelection="true"
          @selection-change="handleSelectionChange"
        >
          <template #settlementBatchName="{ row }">
            <span class="batch-name-link" @click="jumpToReport(row.settlementBatchName)">{{ row.settlementBatchName }}</span>
          </template>
          <!-- 抵扣金额 -->
          <template #deductionAmount="{ row }">
            <span v-if="row.deductionAmount" style="color: blue">
              <el-button
                type="text"
                size="small"
                @click="seeDeductionRecords(row)"
                >{{ row.deductionAmount }}</el-button
              >
            </span>
            <span v-else>{{ row.deductionAmount || 0 }}</span>
          </template>

          <template #operation="{ row }">
            <el-tooltip effect="dark" content="支付记录" placement="top-end">
              <el-button
                type="info"
                content="支付记录"
                icon="el-icon-info"
                circle
                size="mini"
                @click="record(row)"
              >
              </el-button>
            </el-tooltip>
            <el-tooltip effect="dark" content="支付" placement="top-end">
              <el-button
                type="primary"
                icon="el-icon-coin"
                size="mini"
                @click="pay(row)"
                style="margin-left: 5px"
                circle
              ></el-button>
            </el-tooltip>
            <el-tooltip effect="dark" content="查看" placement="top-end">
              <el-button
                type="info"
                icon="el-icon-view"
                size="mini"
                style="margin-left: 5px"
                circle
                @click="viewAndEdit(row, true)"
              ></el-button>
            </el-tooltip>
            <el-tooltip effect="dark" content="修改" placement="top-end">
              <el-button
                type="warning"
                icon="el-icon-edit"
                size="mini"
                style="margin: 0 5px"
                circle
                @click="handleEditClick(row)"
              ></el-button>
            </el-tooltip>
            <el-tooltip effect="dark" content="操作记录" placement="top-end">
              <el-button
                type="info"
                icon="el-icon-s-operation"
                size="mini"
                @click="operationRecord(row)"
                style="margin-right: 5px; margin-left: 0px"
                circle
              ></el-button>
            </el-tooltip>
            <el-tooltip effect="dark" content="删除" placement="top-end">
              <el-popconfirm title="确认删除吗？" @confirm="deleteData(row)">
                <el-button
                  content="删除"
                  slot="reference"
                  type="danger"
                  icon="el-icon-delete"
                  circle
                  size="mini"
                ></el-button>
              </el-popconfirm>
            </el-tooltip>
          </template>
        </BaseTable>
      </div>
    </div>
    <!-- 支付弹窗 -->
    <el-dialog
      :title="isMergePay ? '合并支付' : '直接支付'"
      :visible.sync="dialogPay"
      width="50%"
      @close="dialogClose"
      :close-on-click-modal="false"
    >
      <div>
        <div
          style="
            margin-left: 31px;
            margin-bottom: 20px;
            display: flex;
            align-items: flex-start;
          "
        >
          <div style="flex: 0 0 112px">当前结算单批次：</div>
          <span>{{ paySettlements }}</span>
        </div>
        <div style="margin-left: 31px; margin-bottom: 20px">
          <span>剩余待付金额：</span>
          <span>{{ needToPayAmount }}</span>
        </div>
      </div>
      <el-form
        :model="formPay"
        size="small"
        label-width="100px"
        style="padding-right: 20px"
        :rules="payRules"
        ref="formPayRefs"
      >
        <el-form-item label="付款时间" prop="paymentTime">
          <el-date-picker
            style="width: 100%"
            v-model="formPay.paymentTime"
            type="datetime"
            placeholder="选择付款时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="付款金额" prop="paymentAmount">
          <el-input
            type="text"
            v-model="formPay.paymentAmount"
            placeholder="请输入付款金额"
          ></el-input>
        </el-form-item>
        <el-form-item label="付款方式" prop="paymentMethodDictId">
          <el-select
            filterable
            v-model="formPay.paymentMethodDictId"
            style="width: 100%"
            @change="changePay"
            placeholder="请选择"
          >
            <el-option
              v-for="item in payList"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="付款凭证">
          <UpLoad
            :fileSize="100"
            ref="uploadRefs"
            :accept="'all'"
            @remove="removeFile"
            :limit="100"
            @uploadSuccess="handleUploadSuccess"
          ></UpLoad>
        </el-form-item>
        <el-form-item label="备注" prop="remarks">
          <el-input
            type="textarea"
            maxlength="500"
            v-model="formPay.remarks"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitPay" size="small"
          >提 交</el-button
        >
      </span>
    </el-dialog>
    <!-- 支付记录弹窗组件 -->
    <PaymentRecord 
      ref="paymentRecordRefs" 
      @see-merge-records="seeMergeRecords"
      @see-file-list="seeFileList"
    />

    <el-dialog
      :title="addForm.isSee ? '结算单详情' : '编辑'"
      :visible.sync="dialogNewSettlement"
      fullscreen
      custom-class="settlement-fullscreen-dialog"
      :close-on-click-modal="false"
      :before-close="cancel"
    >
      <newSettlement
        ref="newSettlementRefs"
        :addForm="addForm"
        @closeDialog="closeDialog"
      ></newSettlement>
      <span slot="footer" class="dialog-footer" v-show="!addForm.isSee">
        <el-button type="success" size="small" @click="submitSettlement(3)"
          >保存为预结算</el-button
        >
        <el-button type="primary" size="small" @click="submitSettlement(null)"
          >提 交</el-button
        >
        <el-button size="small" @click="cancel">取 消</el-button>
      </span>
    </el-dialog>
    <Record ref="recordRefs" />
    <!-- 文件列表 -->
    <FileList ref="fileListRefs"></FileList>
    <!-- 抵扣记录 -->
    <DeductionRecord ref="deductionRecordRefs" />
    <!-- 合并支付记录 -->
    <MergePaymentRecords ref="mergePaymentRecordsRefs" />
    <!-- 确认修改组件 -->
    <ConfirmEdit 
      ref="confirmEditRefs" 
      @confirm-edit="handleConfirmEdit"
    />
  </div>
</template>

<script>
import BaseTable from "@/components/BaseTable";
import newSettlement from "@/views/settlement-model/tobe-confirmed/components/newSettlement.vue";
import DeductionRecord from "@/views/settlement-model/components/DeductionRecord.vue";
import MergePaymentRecords from "@/views/settlement-model/components/MergePaymentRecords.vue";
import UpLoad from "@/components/UpLoad";
import { listDictByType } from "@/components/admin/common/util.js";
import { validateNumber } from "@/utils/index";
import Record from "@/components/Record";
import FileList from "@/components/FileList";
import Big from "big.js";
import AmountStatistics from "@/views/settlement-model/components/AmountStatistics.vue";
import PaymentRecord from "@/views/settlement-model/components/PaymentRecord.vue";
import ConfirmEdit from "@/views/settlement-model/components/ConfirmEdit.vue";
export default {
  name: "TobeConfirmed",
  components: {
    BaseTable,
    UpLoad,
    newSettlement,
    Record,
    FileList,
    DeductionRecord,
    MergePaymentRecords,
    AmountStatistics,
    PaymentRecord,
    ConfirmEdit,
  },
  data() {
    return {
      formObj: {
        installerIds: [],
        settlementBatchName: "",
        companyIds: [],
      },
      tableData: [],
      amountStatistics: {},
      columns: [
        {
          prop: "settlementBatchName",
          label: "结算批次名称",
          slot: "settlementBatchName",
          // showOverflowTooltip: true,
        },
        {
          prop: "totalAmount",
          label: "总金额",
        },
        {
          prop: "responsibleUserIdStr",
          label: "结算师傅名称",
        },
        {
          prop: "companyIdStr",
          label: "公司名称",
        },
        {
          prop: "paidAmount",
          label: "已付金额",
        },
        {
          prop: "deductionAmount",
          label: "抵扣金额",
          slot: "deductionAmount",
        },
        {
          prop: "remainingAmount",
          label: "剩余金额",
        },
        {
          prop: "createTime",
          label: "创建时间",
          width: 135,
        },
        {
          prop: "createdByStr",
          label: "创建人",
        },
        {
          prop: "updateTime",
          label: "修改时间",
          width: 135,
          // showOverflowTooltip: true,
        },
        {
          prop: "updatedByStr",
          label: "修改人",
          showOverflowTooltip: true,
        },
      ],
      dialogPay: false,
      formPay: {
        remarks: "",
        paymentTime: "",
        paymentAmount: "",
        paymentMethod: "",
        paymentMethodDictId: "",
        settlementOrderIds: [], // 关联的结算单id
        attachmentIds: [], // 付款凭证
        userId: "", // 师傅id
      },
      payRules: {
        paymentTime: [
          { required: true, message: "请选择付款时间", trigger: "change" },
        ],
        paymentAmount: [
          { required: true, message: "请输入金额", trigger: "blur" },
          { validator: validateNumber, trigger: "blur" },
        ],
        paymentMethodDictId: [
          { required: true, message: "请选择付款方式", trigger: "change" },
        ],
      },
      payList: [],
      companyList: this.$store.state.company || [],
      allUserList: this.$store.state.allUserList || [],
      total: 0,
      page: {
        size: 10,
        current: 1,
      },
      currentRow: {},
      selectedRows: [],
      addForm: {},
      dialogNewSettlement: false,
      queryFormSettlementList: [],
    };
  },
  computed: {
    isMergePay() {
      return (
        Array.isArray(this.formPay.settlementOrderIds) &&
        this.formPay.settlementOrderIds.length > 1
      );
    },
    needToPayAmount() {
      if (this.isMergePay) {
        return this.selectedRows.reduce(
          (sum, item) => sum.plus(item.remainingAmount),
          Big(0)
        );
      } else {
        return this.currentRow.remainingAmount || 0;
      }
    },
    paySettlements() {
      if (Array.isArray(this.currentRow)) {
        return (
          this.currentRow.map((item) => item.settlementBatchName).join(",") ||
          ""
        );
      }
      return this.currentRow.settlementBatchName;
    },
  },
  beforeCreate() {
    listDictByType("settlement_payment_method").then((res) => {
      if (res.status === 200) {
        this.payList = res.data;
      }
    });
  },
  created() {
    this.getSettlementList();
    this.loadAllUserList();
    // 处理从报表页面跳转过来的查询参数
    this.handleRouteQuery();
  },
  methods: {
    // 加载所有用户列表
    async loadAllUserList() {
      try {
        // 调用store的action来获取最新的用户列表
        await this.$store.dispatch('setAllUserList');
        // 更新本地数据
        this.allUserList = this.$store.state.allUserList;
      } catch (error) {
        console.error('加载用户列表失败:', error);
        this.$message.error('加载用户列表失败');
      }
    },
    handleUploadSuccess(res) {
      this.formPay.attachmentIds.push(res);
    },

    seeMergeRecords(row) {
      this.$refs.mergePaymentRecordsRefs.open(row.id);
    },
    seeDeductionRecords(row) {
      this.$refs.deductionRecordRefs.open(row.id);
    },
    handleSelectionChange(val) {
      this.selectedRows = val;
    },
    seeFileList(ids) {
      if (!ids) {
        this.$message.warning("暂无可查看的附件");
        return;
      }
      const filtList = String(ids)
            .split(",")
            .map((item) => item && item.trim())
            .filter(Boolean);
      if (!filtList.length) {
        this.$message.warning("暂无可查看的附件");
        return;
      }
      this.$refs.fileListRefs.open(filtList);
    },
    operationRecord(row) {
      this.$refs.recordRefs.open(row);
    },
    removeFile(file, fileList) {
      this.formPay.attachmentIds = fileList.map((item) => item.uid);
    },
    getSettlementList() {
      this.axios({
        method: "post",
        url: "/pending-settlement-order/listSettlementName?status=1",
      }).then((res) => {
        this.queryFormSettlementList = res.data.data;
      });
    },
    changePay(val) {
      const data = this.payList.find((item) => item.id == val);
      this.formPay.paymentMethod = data.label;
    },
    record(row) {
      this.$refs.paymentRecordRefs.open(row.id);
    },
    viewAndEdit(row, type) {
      this.addForm = {
        isSee: type,
        id: row.id,
        settlementBatchName: row.settlementBatchName,
        responsibleUserId: row.responsibleUserId,
      };
      this.dialogNewSettlement = true;
    },
    
    // 处理修改按钮点击
    handleEditClick(row) {
      this.$refs.confirmEditRefs.open(row);
    },
    
    // 确认修改操作
    handleConfirmEdit(row) {
      // 刷新页面数据
      this.getPageData(false);
    },
    submitPay() {
      if (this.formPay.attachmentIds.length > 0) {
        this.formPay.attachmentIds = this.formPay.attachmentIds.join(",");
      } else {
        this.formPay.attachmentIds = "";
      }
      this.$refs.formPayRefs.validate((valid) => {
        if (valid) {
          const data = { ...this.formPay };

          this.axios({
            url: "/v1/web/settlement/payment-record/add",
            method: "post",
            data,
          }).then((res) => {
            if (res.data.code == 200) {
              this.$message.success("付款成功");
              this.dialogClose();
              this.getPageData(false);
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      });
    },
    pay(data) {
      if (data.remainingAmount < 0) {
        this.$message.warning("当前结算单剩余金额小于0，不能进行支付");
        return;
      }
      this.formPay.userId = data.responsibleUserId;
      this.formPay.settlementOrderIds = []; // 清空之前的结算单id
      this.formPay.settlementOrderIds.push(data.id); // 单个结算单支付
      this.dialogPay = true;
      this.currentRow = data;
    },
    payMerge() {
      if (this.selectedRows.length == 0) {
        this.$message.warning("请选择要合并支付的结算单");
        return;
      }

      if (this.selectedRows.length == 1) {
        this.$message.warning("最少两个结算单才能合并支付，目前选择了一个");
        return;
      }

      const isAllSame = this.selectedRows.every(
        (item) =>
          item.responsibleUserIdStr ===
          this.selectedRows[0].responsibleUserIdStr
      );
      if (!isAllSame) {
        this.$message.warning("请选择同一结算师傅的结算单进行合并支付");
        return;
      }

      const total = this.selectedRows.reduce(
        (sum, item) => sum.plus(item.remainingAmount),
        Big(0)
      );
      if (total.lte(0)) {
        this.$message.warning("合并支付的结算单累加金额不能小于等于0");
        return;
      }

      this.formPay.userId = this.selectedRows[0].responsibleUserId;
      this.formPay.settlementOrderIds = this.selectedRows.map(
        (item) => item.id
      );
      this.dialogPay = true;
      this.currentRow = this.selectedRows;
    },
    onSizeChange(val) {
      this.page.size = val;
      this.getPageData(false);
    },
    onCurrentChange(val) {
      this.page.current = val;
      this.getPageData(false);
    },
    getPageData(flag) {
      if (flag) {
        this.page = {
          size: 10,
          current: 1,
        };
      }
      const data = {
        page: this.page.current,
        size: this.page.size,
        queryInfoParams: {
          ...this.formObj,
          status: 1,
        },
      };
      this.axios({
        url: "/v1/web/settlement-manage/settlement-order/listPayment",
        method: "post",
        data,
      }).then((res) => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.list;
          this.total = res.data.data.total;
          this.amountStatistics = res.data.data.extend;
          this.$store.dispatch("setPaymentCount");
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    deleteData(row) {
      this.axios({
        method: "DELETE",
        url: `/v1/web/settlement-manage/settlement-order/del/${row.id}`,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$message.success("删除成功");
          this.getPageData(false);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    reset() {
      this.$refs.formObjRefs.resetFields();
      this.getPageData(true);
    },
    dialogClose() {
      this.dialogPay = false;
      this.$refs.formPayRefs.resetFields();
      this.formPay.attachmentIds = [];
      this.$refs.uploadRefs.fileList = [];
    },
    cancel() {
      if (this.addForm.isSee) {
        this.dialogNewSettlement = false;
      } else {
        this.$confirm(
          "此操作会关闭当前页面且数据不会被保存,是否继续?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(() => {
            this.$refs.newSettlementRefs.clearData();
            this.dialogNewSettlement = false;
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消关闭",
            });
          });
      }
    },
    closeDialog(flag) {
      this.dialogNewSettlement = false;
      this.getPageData(flag);
    },
    submitSettlement(status) {
      this.$confirm("是否要提交本次操作?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (this.addForm.id) {
            this.$refs.newSettlementRefs.editSubmit(status);
          } else {
            this.$refs.newSettlementRefs.submit(status);
          }
        })
        .catch((err) => {
          this.$message({
            type: "info",
            message: "已取消提交",
          });
        });
    },
    jumpToReport(batchName) {
      // 跳转到结算报表页面并自动查询指定批次
      this.$router.push({
        path: '/home-admin/settlementManage/report',
        query: { 
          settlementBatchName: batchName,
          autoSearch: 'true'
        }
      });
    },
    handleRouteQuery() {
      // 处理从报表页面跳转过来的查询参数
      const query = this.$route.query;
      if (query.settlementBatchName && query.autoSearch === 'true') {
        // 设置结算批次名称并自动查询
        this.formObj.settlementBatchName = query.settlementBatchName;
        // 等待数据加载完成后再查询
        this.$nextTick(() => {
          setTimeout(() => {
            this.getPageData(true);
          }, 500); // 给一点时间让下拉选项加载完成
        });
      } else {
        // 正常加载数据
        this.getPageData(true);
      }
    }
  },
};
</script>

<style scoped>
.container {
  width: 100%;
  height: 100%;
  padding: 20px;
  background-color: rgb(238, 238, 238);
  box-sizing: border-box;
}

.container_table {
  background-color: #fff;
  border-radius: 8px;
  padding: 20px 5px 20px 20px;
}
.batch-name-link {
  color: #409EFF;
  cursor: pointer;
}
.batch-name-link:hover {
  text-decoration: underline;
}
</style>
